import Input from '@/shared/components/Inputs/Input';
import {FIELD, FIELD_LABEL, FORM, PLACEHOLDER} from '@/utils/constants';
import {setRequiredLabel} from '@/utils/helpers';
import {Field} from 'formik';
import {Box} from '@mui/material';
import {FC} from 'react';
import {createTeamMemberFormStyle} from '../CreateTeamMemberForm/CreateTeamMemberForm.styles';

const EditTeamMemberForm: FC = () => {

  return (
    <Box>
      <Box sx={createTeamMemberFormStyle.form} component={FORM}>
        <Box sx={createTeamMemberFormStyle.formRow}>
          <Field
            id={FIELD.firstName}
            name={FIELD.firstName}
            placeholder={PLACEHOLDER.enterFirstName}
            label={setRequiredLabel(FIELD_LABEL.firstName)}
            component={Input}
          />

          <Field
            id={FIELD.lastName}
            name={FIELD.lastName}
            placeholder={PLACEHOLDER.enterLastName}
            label={setRequiredLabel(FIELD_LABEL.lastName)}
            component={Input}
          />
        </Box>
        <Field
          id={FIELD.email}
          name={FIELD.email}
          placeholder={PLACEHOLDER.enterEmail}
          label={setRequiredLabel(FIELD_LABEL.email)}
          component={Input}
        />
      </Box>
    </Box>
  );
};

export default EditTeamMemberForm;
